import { createFileRoute, Link, ToPathOption } from "@tanstack/react-router"
import { GridList, GridListItem } from "react-aria-components"
import { useTranslation } from "react-i18next"

import { router } from "@/App"
import { IconName } from "@/assets/icons"
import Icon from "@/globalComponents/atoms/Icon"
import { cn } from "@/utilities/etc"

import styles from "./index.module.css"

export const Route = createFileRoute("/_authenticated/account/")({
  component: RouteComponent,
})

interface MenuItem {
  title: string
  iconName: IconName
  to: ToPathOption<typeof router>
}

function RouteComponent() {
  const { t } = useTranslation()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  const menuItems: MenuItem[] = [
    {
      title: t("account.personalInfo"),
      iconName: "person",
      to: "/account/personal-information",
    },
    {
      title: t("account.vehicles"),
      iconName: "car",
      to: "/account/vehicles",
    },
    {
      title: t("account.savedPaymentMethods.header"),
      iconName: "creditCard",
      to: "/account/saved-payment-methods",
    },
    {
      title: t("account.updatePassword"),
      iconName: "passwordInput",
      to: "/account/update-password",
    },
  ]

  return (
    <GridList
      items={menuItems}
      className={styles.linkList}
      selectionBehavior="replace"
      aria-label={t("account.linkListLabel")}
    >
      {(item) => (
        <GridListItem
          id={item.to}
          key={item.to}
          textValue={item.title}
          onAction={() => navigate({ to: item.to, search })}
        >
          <Link
            to={item.to}
            search={search}
            className={cn(styles.links, "bold")}
          >
            <div className={styles.linkIcon}>
              <Icon name={item.iconName} />
            </div>
            {item.title}
            <Icon name="chevronRight" />
          </Link>
        </GridListItem>
      )}
    </GridList>
  )
}
